'use client';
import React from 'react';
import Image from 'next/image';
import Modal from 'react-modal';
import { InlineWidget } from 'react-calendly';
import MWSVG from '../common/svg';

const OdooImplementationPacks = () => {
    const customStyles = {
        overlay: {
            zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.6)',
            padding: 0,
        },
        content: {
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#fff',
            border: '0',
            maxWidth: '600px',
            width: '90%',
            padding: '0',
            paddingTop: '20px',
        },
    };

    const [modalIsOpen, setIsOpen] = React.useState(false);

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div className="section-py">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
                            <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                                Moweb&apos;s Odoo Implementation Packs
                            </h2>
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                Accelerate Success: Moweb&apos;s Odoo Implementation Packs with 98% Guarantee!
                            </p>
                        </div>
                    </div>
                    <div className="row grid xl:grid-cols-1 lg:grid-cols-1 md:grid-cols-1 pb-50">
                        <div className="odoo-imp-table table-responsive">
                            <table className="table-fixed">
                                <tbody>
                                    <tr>
                                        <th className="empty-text"></th>
                                        <th className="rounded-top">Starter</th>
                                        <th>Basic</th>
                                        <th>Standard</th>
                                        <th>Custom</th>
                                        <th className="rounded-end border-r-end">Pro</th>
                                    </tr>
                                    <tr>
                                        <td className="fw-600 bg-grey">Recommended for</td>
                                        <td className="text-center bg-grey">Simple Apps 1-5 users</td>
                                        <td className="text-center bg-grey">Simple Apps</td>
                                        <td className="text-center bg-grey">Advanced Apps and Data Import</td>
                                        <td className="text-center bg-grey">Advanced Apps, Data Import and Customizations</td>
                                        <td className="text-center bg-grey">Advanced Apps, Data Import and Customizations</td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Dedicated Customer Success Consultant</td>
                                        <td className="text-center bg-primary text-white fs-lg fw-700">5 hours</td>
                                        <td className="text-center bg-primary text-white fs-lg fw-700">25 hours</td>
                                        <td className="text-center bg-primary text-white fs-lg fw-700">50 hours</td>
                                        <td className="text-center bg-primary text-white fs-lg fw-700">100 hours</td>
                                        <td className="text-center bg-primary text-white fs-lg fw-700">200 hours</td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Project Management</td>
                                        <td className="text-center"></td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Email + Phone Support</td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Training & Coaching</td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Configuration</td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Data Import Assistance</td>
                                        <td className="text-center"></td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Onsite Consulting *</td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey fw-600">App Customization **</td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Customizations (forms, reports, workflow)</td>
                                        <td className="text-center"></td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Developments</td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="bg-grey">Performance Issues</td>
                                        <td className="text-center"></td>
                                        <td className="text-center"></td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                        <td className="text-center">
                                            <Image
                                                alt="check-filled"
                                                src="/img/icon-square-rounded-check-filled.svg"
                                                height="24"
                                                width="24"
                                                loading="lazy"
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={6} className="text-center py-10">
                                            <button
                                                className="btn btn-primary self-baseline"
                                                aria-label="Book a call"
                                                onClick={() => {
                                                    openModal();
                                                }}
                                            >
                                                Book a Call
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="grid xl:grid-cols-1 lg:grid-cols-1 md:grid-cols-1 pb-50">
                        <p className="mb-2.5">* Travel time billed; Travel expenses billed separately.</p>
                        <p className="mb-2.5">
                            ** Extra monthly charges apply for the maintenance of extra modules / lines of code, by the Odoo team!
                        </p>
                        <p className="mb-0">*** A special discount applies to new customers, for their first pack only.</p>
                    </div>
                </div>
            </div>

            <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles}>
                <div onClick={closeModal} className="text-secondary text-right btn-close absolute left-5 cursor-pointer pt-5">
                    <MWSVG id="ic_close" svgClassName="text-secondary" />
                </div>
                <InlineWidget
                    styles={{
                        height: '100%',
                    }}
                    url="https://calendly.com/mowebsales/moweb-sales"
                />
            </Modal>
        </>
    );
};

export default OdooImplementationPacks;
